<div class="dropdown">
    <!-- Dropdown toggle -->
    <div class="c-dropdown-toggle" data-bs-toggle="dropdown" [attr.data-testid]="testIdPrefix ? testIdPrefix + '-user-menu-button' : null">
       <span class="user-name">
          {{ user.fullname }}
       </span>
       <div class="arrow-container">
          <img src="assets/icons/down-arrow-white.svg" />
       </div>
    </div>
 
    <!-- Dropdown menu -->
    <div class="dropdown-menu">
       <div class="menu-container">
          <!-- Profile Image -->
          <div class="profile-image">
             <img [src]="user.imageUrl" onerror="this.src='assets/icons/user-blue-menu.svg'" />
          </div>
 
          <!-- User Info -->
          <div class="user-details">
             <span class="user-name">
                {{ user.fullname }}
             </span>
             <span class="user-email ellipsis"
                data-bs-toggle="user.email.length > 25 ? 'tooltip' : 'disable'"
                title="{{ user.email }}"
             >
                {{ user.email }}
             </span>
             <a class="user-role">
                {{ user.role }}
             </a>
          </div>
 
          <!-- Divider -->
          <div class="divider">
             <div class="line"></div>
          </div>
 
          <!-- Menu -->
          <div class="dropdown-menu-body">
             <a class="dropdown-item" data-testid="header-user-menu-navigate-link" (click)="clientId ? navigateTo(profileUrl) : null" [class.disabled]="!clientId"
                [attr.data-testid]="testIdPrefix ? testIdPrefix + '-user-menu-profile-link' : null">
                <div class="img-container">
                   <img class="dropdown-icon profile" src="assets/icons/user-profile-gray.svg" />
                </div>
                
                <span i18n="@@myProfileHeader">My Profile</span>
             </a>
             <a class="dropdown-item" (click)="onLogout()" [attr.data-testid]="testIdPrefix ? testIdPrefix + '-user-menu-sign-out-button' : null">
                <div class="img-container">
                   <img class="dropdown-icon profile" src="assets/icons/logout-grey.svg" />
                </div>
                <span i18n="@@signOut">Sign out</span>
             </a>
          </div>
       </div>
    </div>
 </div>
 